import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconWrenchTuneUp = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={42}
    height={40}
    fill="none"
    viewBox="0 0 42 40"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="url(#icon-wrench-tune-up_svg__a)"
      d="M40.61 9.61c.468 1.874.468 3.906-.157 6.015-1.172 4.844-5.234 8.516-10.078 9.297-2.11.39-4.14.156-5.938-.469L10.531 38.36C9.36 39.453 7.875 40 6.547 40c-1.406 0-2.813-.547-3.828-1.719-2.266-2.187-2.266-5.703 0-7.89l13.906-13.907c-.625-1.875-.86-3.906-.39-5.937.703-4.844 4.453-8.906 9.296-10.078C27.563 0 29.594 0 31.47.469c.937.234 1.25 1.406.547 2.11L26 8.515v6.562h6.563L38.5 9.063c.703-.704 1.875-.391 2.11.546ZM7.25 35.624c1.016 0 1.875-.781 1.875-1.875 0-1.016-.86-1.875-1.875-1.875-1.094 0-1.875.86-1.875 1.875 0 1.094.781 1.875 1.875 1.875Z"
    />
    <defs>
      <linearGradient
        id="icon-wrench-tune-up_svg__a"
        x1={41}
        x2={1}
        y1={0}
        y2={40}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCF4BF" />
        <stop offset={0.18} stopColor="#EFC862" />
        <stop offset={0.73} stopColor="#CD9832" />
        <stop offset={1} stopColor="#BB811B" />
      </linearGradient>
    </defs>
  </svg>
));
export default SvgIconWrenchTuneUp;
